import React, { useState, useEffect } from 'react'
import axios from 'axios'
// eslint-disable-next-line
import { Button, Space, Breadcrumb, Modal, Popover } from 'antd'
// eslint-disable-next-line
import {
  getHeaders,
  errorNotification,
  successNotification,
  carOrdersUrl
} from '../../config'
import Update from './Update'
// import OrderTableSection from './TableSection'
import PageLoader from '../../components/Layouts/PageLoader'
import { Link } from 'react-router-dom'
import { PENDING } from 'app-constants'
import PageTitle from 'components/PageTitle'

const Detail = props => {
  const [order, setOrder] = useState({
    car: '',
    user: '',
    quantity: '',
    paymentStatus: '',
    note: ''
  })
  const [payload, setPayload] = useState({})
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [modalKey, setModalKey] = useState(1)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const getOrder = () => {
    setLoading(true)
    axios
      // eslint-disable-next-line react/prop-types
      .get(carOrdersUrl + '/' + props.match.params.id, {
        headers: getHeaders()
      })
      .then(res => {
        setLoading(false)
        setOrder(res.data)
        setPayload(res.data)
      })
      .catch(() => {
        setLoading(false)
        errorNotification('Error getting order details, retry.')
      })
  }

  const handleDeleteOrder = () => {
    axios
      // eslint-disable-next-line react/prop-types
      .delete(carOrdersUrl + '/' + props.match.params.id, {
        headers: getHeaders()
      })
      .then(() => {
        successNotification('Order Deleted')
        setShowDeleteModal(false)
        // eslint-disable-next-line react/prop-types
        props.history.push('/car-orders')
      })
      .catch(() => {
        errorNotification('Error deleting order, retry.')
      })
  }

  useEffect(() => {
    getOrder()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (showModal) {
      setModalKey(modalKey + 1)
    }
    // eslint-disable-next-line
  }, [showModal])

  // eslint-disable-next-line
  let nf = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

  return (
    <PageLoader className="container" loading={loading}>
      <PageTitle title="Car order details" />
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/car-orders">Car Order</Breadcrumb.Item>
            <Breadcrumb.Item>Car Order Details</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="card mb-4rem">
                <div className="card-header">Car Order Details</div>
                <div className="card-body">
                  <div
                    className="row"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Car Details</b>
                      </div>{' '}
                      <Popover
                        content={
                          <div>
                            <img
                              src={order.car && order.car.image}
                              height={150}
                              width={150}
                              alt="product thumbnail"
                            />
                          </div>
                        }
                        title={`Current Price: ${
                          order.car.profitCurrency?.symbol
                        } ${nf.format(order.car.price)}`}
                        trigger="hover"
                      >
                        {order.car && (
                          <Link to={`/cars/${order.car.id}`} target="blank">
                            {`${order.car.year} ${order.car.make.name} ${order.car.model.name} ${order.car.trim}`}
                          </Link>
                        )}
                      </Popover>
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Customer</b>
                      </div>
                      <>
                        {order.user && order.user.firstName
                          ? order.user.firstName + ' '
                          : ''}
                        {order.user && order.user.phoneNumber}
                      </>
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Order Quantity</b>
                      </div>
                      {order.quantity}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Order price (per unit)</b>
                      </div>
                      {`${order.car.profitCurrency?.symbol} ${nf.format(
                        order.pricePerUnit
                      )}`}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Note</b>
                      </div>
                      {`${order.note}`}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Order Payment Status</b>
                      </div>
                      {order.paymentStatus}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>ETA</b>
                      </div>
                      {order.eta ? (
                        <>
                          <div>{new Date(order.eta).toDateString()} </div>
                        </>
                      ) : (
                        'N/A'
                      )}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Ordered On</b>
                      </div>
                      {order.orderedOn ? (
                        <>
                          <div>{new Date(order.orderedOn).toDateString()} </div>
                        </>
                      ) : (
                        'N/A'
                      )}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Shipping Company</b>
                      </div>
                      {order.shippingCompany ? (
                        <>
                          <div>
                            {order.shippingCompany.name}{' '}
                            {order.shippingCompany.origin.country}
                          </div>
                        </>
                      ) : (
                        'N/A'
                      )}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Created On</b>
                      </div>
                      {new Date(order.createdAt).toDateString()}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Updated On</b>
                      </div>
                      {new Date(order.updatedAt).toDateString()}
                    </div>

                    <div className="col-md-12">
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'flex-end',
                          marginBottom: '20px'
                        }}
                      >
                        <Space>
                          <Button
                            type="primary"
                            onClick={() => {
                              setShowModal(true)
                            }}
                            loading={loading}
                          >
                            Update Car Order
                          </Button>
                          {payload.paymentStatus === PENDING ? (
                            <Button
                              type="primary"
                              onClick={() => {
                                setShowDeleteModal(true)
                              }}
                              loading={loading}
                              danger
                            >
                              Delete Order
                            </Button>
                          ) : null}
                        </Space>
                      </div>
                    </div>

                    <Modal
                      title="Update Order Details"
                      centered
                      open={showModal}
                      onOk={() => setShowModal(false)}
                      onCancel={() => setShowModal(false)}
                      footer={null}
                      width={1000}
                    >
                      <Update
                        key={modalKey}
                        order={payload}
                        handleCancel={() => {
                          setShowModal(false)
                          getOrder()
                        }}
                      />
                    </Modal>

                    <Modal
                      title="Do You Really Want to Delete This Order?"
                      centered
                      open={showDeleteModal}
                      onOk={() => setShowDeleteModal(false)}
                      onCancel={() => setShowDeleteModal(false)}
                      footer={null}
                    >
                      <div
                        className="p-3"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center'
                        }}
                      >
                        <span className="text-danger mb-3">
                          Go ahead and delete order?
                        </span>
                        <Button
                          type="danger"
                          onClick={() => {
                            handleDeleteOrder()
                          }}
                          loading={loading}
                        >
                          Delete Order
                        </Button>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>

              {/* {order && (
                <OrderTableSection
                  order={order}
                  handleCalback={() => {
                    getOrder()
                  }}
                />
              )} */}
            </div>
          </div>
        </div>
      </div>
    </PageLoader>
  )
}

export default Detail
